<template>
  <div
    class="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-md dark:border-slate-600 dark:bg-slate-800"
  >
    <div class="flex flex-col gap-2 p-2">
      <div class="flex items-center justify-between gap-2">
        <RouterLink :to="showRoute" class="min-w-0">
          <h3 class="truncate text-base font-bold text-gray-900">
            {{ invoice.reference }}
          </h3>
        </RouterLink>
        <div class="flex shrink-0 items-center gap-1">
          <PeppolStatusBadge :invoice="invoice" />
          <span
            class="inline-block rounded-sm bg-primary-500 px-2 py-0.5 text-xs font-medium text-white"
          >
            {{ $t(`enums.invoicing.status.${invoice.status}`) }}
          </span>
        </div>
      </div>

      <div class="grid grid-cols-2 rounded-sm border">
        <div
          v-for="(amount, index) in amounts"
          :key="amount.label"
          class="flex flex-col px-2 py-1"
          :class="{
            'border-r': index % 2 === 0,
            'border-b': index < 2
          }"
        >
          <span class="text-xxs leading-none capitalize-first">
            {{ amount.label }}
          </span>
          <span class="font-semibold">
            {{ $h.formatCurrency(amount.value) }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex flex-row bg-primary-50 dark:bg-slate-700">
      <RouterLink
        :to="showRoute"
        class="flex min-w-0 flex-1 items-center justify-center gap-2 px-2 py-2 text-gray-700 hover:bg-primary-100 dark:text-gray-200"
      >
        <FontAwesomeIcon :icon="['fal', 'eye']" />
        <span class="capitalize-first">{{ $t('button.see') }}</span>
      </RouterLink>
      <RouterLink
        :to="{
          name: 'invoice_print_route',
          params: { invoicing_id: invoice.id }
        }"
        class="flex min-w-0 flex-1 items-center justify-center gap-2 px-2 py-2 text-gray-700 hover:bg-primary-100 dark:text-gray-200"
      >
        <FontAwesomeIcon :icon="['fal', 'print']" />
        <span class="capitalize-first">{{ $t('global.print') }}</span>
      </RouterLink>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import PeppolStatusBadge from '@c/Partner/Peppol/PeppolStatusBadge.vue'

/**
 * An invoice (or quote, purchase order, credit note) of a work's invoicing
 * tab, as FM's DossierFormInvoicingCard.
 */
export default {
  name: 'WorkFormInvoicingCard',
  components: { FontAwesomeIcon, PeppolStatusBadge },
  props: {
    invoice: { type: Object, required: true }
  },
  computed: {
    showRoute() {
      return {
        name: 'work_form_invoicing_show_route',
        params: { invoicing_id: this.invoice.id }
      }
    },
    amounts() {
      return [
        {
          label: this.$t('attributes.total_htva'),
          value: this.invoice.total_htva
        },
        {
          label: this.$t('attributes.total_paid'),
          value: this.invoice.total_paid
        },
        {
          label: this.$t('attributes.total_tvac'),
          value: this.invoice.total_tvac
        },
        {
          label: this.$t('attributes.outstanding_balance'),
          value: this.invoice.solde
        }
      ]
    }
  }
}
</script>
